import { render, staticRenderFns } from "./addFaxDetectDialog.vue?vue&type=template&id=4b7e75ed&"
import script from "./addFaxDetectDialog.vue?vue&type=script&lang=js&"
export * from "./addFaxDetectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports